import Vue from 'vue'
import App from './App.vue'
import router from './router'
import AuthService from "./plugins/AuthService";
import vuetify from './plugins/vuetify';
import VueStash from 'vue-stash';
import store from './plugins/store';
import RouterLoader from './plugins/RouterLoader';
import ToastService from "./plugins/ToastService/ToastService.js";

// funciones para inicializar la SPA
// ---------------------------------

function inicializarStore() {

    // inicializa el store
    Vue.use(VueStash);

    // carga la información del token en el store (si es que la tiene)
    if (localStorage.getItem("authInfo")) {
        const authInfo = JSON.parse(localStorage.getItem("authInfo"));
        store.usuario.nombre = authInfo.apellido + " " + authInfo.nombre;
        store.usuario.jerarquiaId = authInfo.jerarquiaId;
        store.usuario.usuarioId = authInfo.id;
    }
}

function inicializarAuth() {

    /// nota: define las rutas de la api segun corresponda
    const baseDev = 'http://localhost:5001';
    const baseDevIUA = 'http://localhost:5000';
    const baseProd = 'https://api.blito.ar';
    const baseProdIUA = 'https://api.blito.ar';
    

    // corrobora el environment si es de produccion o desarrollo
    const env = process.env.NODE_ENV;
    const base = (env.toLowerCase() == "production" ? baseProd : baseDev);
    const baseIUA = (env.toLowerCase() == "production" ? baseProdIUA : baseDevIUA);

    // configura el plugin de autenticacion
    Vue.use(AuthService, {
        router: router,
        base: base,
        baseIUA:baseIUA,
        baseApi: base + '/api/v1',
        refreshApi: '/auth/refresh-token',
        loginApi: '/auth/login',
        logoutApi: '/auth/logout',
        loginRoute: '/login',
        defaultRoute: '/',
    });

}

function inicializarRouterLoader() {
    RouterLoader(router, store);
}

function inicializarInstanciaVue() {
    new Vue({
        router,
        data: { store },
        vuetify,
        render: h => h(App)
    }).$mount('#app')
}

function inicializarToastService() {
    Vue.use(ToastService, {
        store: store
    });
}


// Inicialización de la SPA
// ---------------------------------
function init() {
    inicializarStore();
    inicializarAuth();
    inicializarRouterLoader();
    inicializarToastService();
    inicializarInstanciaVue();

}

// Arranca la app
// --------------------------------------
init();